import { createSelector } from '@reduxjs/toolkit'
import { selectActiveCartReservation } from '@/store/cartSlice/selectors/selectActiveCartReservation'
import { mapSelectedElementSetupDataSelector } from '@/store/mapSlice'
import { getSeatDefaultQuantity } from '@/utils/getSeatDefaultQuantity'

export const filteredSetupItemsSelector = createSelector(
  [mapSelectedElementSetupDataSelector, selectActiveCartReservation],
  (setupData, activeCartReservation) => {
    if (!setupData?.selectedElementSetupItems) {
      return []
    }

    return setupData.selectedElementSetupItems
      .filter((item) => item.max > 0)
      .map((item) => {
        return {
          ...item,
          d: getSeatDefaultQuantity({
            selectedElementCartReservation: activeCartReservation,
            setupItem: item,
          }),
        }
      })
  }
)
